import Vue from 'vue'
import App from './App'
import router from './router'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-102752070-1',
  router,
  autoTracking: {
    exception: true,
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
})

var burgers = document.querySelectorAll('.navbar-burger')

for (var i = 0; i < burgers.length; ++i) {
  burgers[i].addEventListener('click', function (event) {
    var target = event.target.dataset.target
    var $target = document.getElementById(target)
    event.target.classList.toggle('is-active')
    $target.classList.toggle('is-active')
  })
}



// WEBPACK FOOTER //
// ./src/main.js